import { render, staticRenderFns } from "./AutoResolutionDetails.vue?vue&type=template&id=2e565026"
import script from "./AutoResolutionDetails.vue?vue&type=script&lang=js"
export * from "./AutoResolutionDetails.vue?vue&type=script&lang=js"
import style0 from "./AutoResolutionDetails.vue?vue&type=style&index=0&id=2e565026&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports